export var channelEnum;
(function (channelEnum) {
    channelEnum["unknown"] = "unknown";
    channelEnum["admin"] = "admin";
    channelEnum["kiosk"] = "kiosk";
    channelEnum["desktopBrowser"] = "desktopBrowser";
    channelEnum["mobileBrowser"] = "mobileBrowser";
    channelEnum["mobileApp"] = "mobileApp";
    channelEnum["browser"] = "browser";
})(channelEnum || (channelEnum = {}));
export var paymentStatusEnum;
(function (paymentStatusEnum) {
    paymentStatusEnum["initiated"] = "initiated";
    paymentStatusEnum["authorized"] = "authorized";
    paymentStatusEnum["captured"] = "captured";
    paymentStatusEnum["failed"] = "failed";
    paymentStatusEnum["refunded"] = "refunded";
    paymentStatusEnum["cancelled"] = "cancelled";
})(paymentStatusEnum || (paymentStatusEnum = {}));
export var aggregatedPaymentStatusEnum;
(function (aggregatedPaymentStatusEnum) {
    aggregatedPaymentStatusEnum["notPrepaid"] = "notPrepaid";
    aggregatedPaymentStatusEnum["paymentInitiated"] = "paymentInitiated";
    aggregatedPaymentStatusEnum["paymentAuthorized"] = "paymentAuthorized";
    aggregatedPaymentStatusEnum["paymentCaptured"] = "paymentCaptured";
    aggregatedPaymentStatusEnum["paymentFailed"] = "paymentFailed";
    aggregatedPaymentStatusEnum["paymentRefunded"] = "paymentRefunded";
    aggregatedPaymentStatusEnum["paymentCancelled"] = "paymentCancelled";
    aggregatedPaymentStatusEnum["notFound"] = "paymentNotFound";
    aggregatedPaymentStatusEnum["error"] = "error";
})(aggregatedPaymentStatusEnum || (aggregatedPaymentStatusEnum = {}));
export var orderStatusEnum;
(function (orderStatusEnum) {
    orderStatusEnum["pending"] = "pending";
    orderStatusEnum["confirmed"] = "confirmed";
    orderStatusEnum["rejected"] = "rejected";
    orderStatusEnum["basket"] = "basket";
    orderStatusEnum["pending_additional_payment"] = "pending_additional_payment";
})(orderStatusEnum || (orderStatusEnum = {}));
export var createdByEnum;
(function (createdByEnum) {
    createdByEnum["customer"] = "customer";
    createdByEnum["manager"] = "manager";
    createdByEnum["admin"] = "admin";
    createdByEnum["system"] = "system";
})(createdByEnum || (createdByEnum = {}));
export var orderPaymentStatusEnum;
(function (orderPaymentStatusEnum) {
    orderPaymentStatusEnum["postpaid"] = "postpaid";
    orderPaymentStatusEnum["prepaid"] = "prepaid";
})(orderPaymentStatusEnum || (orderPaymentStatusEnum = {}));
export var discountTypeEnum;
(function (discountTypeEnum) {
    discountTypeEnum["twoForOne"] = "twoForOne";
    discountTypeEnum["simpleDiscountInPct"] = "simpleDiscountInPct";
    discountTypeEnum["simpleDiscountFixedAmount"] = "simpleDiscountFixedAmount";
    discountTypeEnum["globalDiscountWithMax"] = "globalDiscountWithMax";
    discountTypeEnum["bulkDiscount"] = "bulkDiscount";
    discountTypeEnum["percentDiscount"] = "percentDiscount";
    discountTypeEnum["familyDiscount"] = "familyDiscount";
})(discountTypeEnum || (discountTypeEnum = {}));
export var vikingOrderTypesEnum;
(function (vikingOrderTypesEnum) {
    vikingOrderTypesEnum["deposit"] = "deposit";
    vikingOrderTypesEnum["final"] = "final";
    vikingOrderTypesEnum["refund"] = "refund";
    vikingOrderTypesEnum["finalRefund"] = "finalRefund";
    vikingOrderTypesEnum["customOrder"] = "customOrder";
    vikingOrderTypesEnum["customRefund"] = "customRefund";
})(vikingOrderTypesEnum || (vikingOrderTypesEnum = {}));
export var vikingApiVersions;
(function (vikingApiVersions) {
    vikingApiVersions["saveReceiptApi"] = "saveReceiptApi";
    vikingApiVersions["webOrderApi"] = "webOrderApi";
})(vikingApiVersions || (vikingApiVersions = {}));
export var shopOptionsAvailableEnum;
(function (shopOptionsAvailableEnum) {
    shopOptionsAvailableEnum["newYearsMenuSoldOut"] = "newYearsMenuSoldOut";
    shopOptionsAvailableEnum["paymentOptions"] = "paymentOptions";
    shopOptionsAvailableEnum["temporarilyClosedOptions"] = "temporarilyClosedOptions";
    shopOptionsAvailableEnum["enabledSubscriptionServices"] = "enabledSubscriptionServices";
    shopOptionsAvailableEnum["deliveryMethods"] = "deliveryMethods";
    shopOptionsAvailableEnum["onlinePosHQ"] = "onlinePosHQ";
    shopOptionsAvailableEnum["tableServing"] = "tableServing";
    shopOptionsAvailableEnum["extraInfoBoxes"] = "extraInfoBoxes";
    shopOptionsAvailableEnum["isShopHidden"] = "isShopHidden";
    shopOptionsAvailableEnum["scannerEnabled"] = "scannerEnabled";
    shopOptionsAvailableEnum["vat"] = "vat";
    shopOptionsAvailableEnum["driveInDeliveryEnabled"] = "driveInDeliveryEnabled";
    shopOptionsAvailableEnum["recommendationEngineEnabled"] = "recommendationEngineEnabled";
    shopOptionsAvailableEnum["recommendationEngineEnabledCarousel"] = "recommendationEngineEnabledCarousel";
    shopOptionsAvailableEnum["recommendationEngineEnabledCarouselDesktop"] = "recommendationEngineEnabledCarouselDesktop";
    shopOptionsAvailableEnum["recommendationEngineEnabledMarketingCard"] = "recommendationEngineEnabledMarketingCard";
    shopOptionsAvailableEnum["isSecretRestaurant"] = "isSecretRestaurant";
    shopOptionsAvailableEnum["sortingByRecommendationEngineEnabled"] = "sortingByRecommendationEngineEnabled";
    shopOptionsAvailableEnum["dmiStationData"] = "dmiStationData";
    shopOptionsAvailableEnum["userTrackingId"] = "userTrackingId";
})(shopOptionsAvailableEnum || (shopOptionsAvailableEnum = {}));
export var feedbackEmailTypesEnum;
(function (feedbackEmailTypesEnum) {
    feedbackEmailTypesEnum["trustPilot"] = "trustPilot";
    feedbackEmailTypesEnum["surveyXact"] = "surveyXact";
})(feedbackEmailTypesEnum || (feedbackEmailTypesEnum = {}));
export var dateRuleTypesEnum;
(function (dateRuleTypesEnum) {
    dateRuleTypesEnum["creationDate"] = "creationDate";
    dateRuleTypesEnum["pickupDate"] = "pickupDate";
    dateRuleTypesEnum["paymentDate"] = "paymentDate";
})(dateRuleTypesEnum || (dateRuleTypesEnum = {}));
export var PaymentProvidersEnum;
(function (PaymentProvidersEnum) {
    PaymentProvidersEnum["Demo"] = "demo";
    PaymentProvidersEnum["Bambora"] = "bambora";
    PaymentProvidersEnum["Nets"] = "nets";
})(PaymentProvidersEnum || (PaymentProvidersEnum = {}));
export var OnlinePosOrderTypeEnum;
(function (OnlinePosOrderTypeEnum) {
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["TAW"] = 1] = "TAW";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["KIOSK"] = 2] = "KIOSK";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["BROWSER_APP"] = 3] = "BROWSER_APP";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["BROWSER_APP_SUBSCRIPTION"] = 4] = "BROWSER_APP_SUBSCRIPTION";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["MOBILE_APP_SUBSCRIPTION"] = 10] = "MOBILE_APP_SUBSCRIPTION";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["MOBILE_APP"] = 11] = "MOBILE_APP";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["KIOSK_SUBSCRIPTION"] = 13] = "KIOSK_SUBSCRIPTION";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["KIOSK_SUBSCRIPTION_EMPLOYEE"] = 14] = "KIOSK_SUBSCRIPTION_EMPLOYEE";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["SUNSET_PLUS_EMPLOYEE"] = 9] = "SUNSET_PLUS_EMPLOYEE";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["SUNSET_PLUS_APP_EMPLOYEE"] = 12] = "SUNSET_PLUS_APP_EMPLOYEE";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["DRIVE_IN_APP"] = 17] = "DRIVE_IN_APP";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["DRIVE_IN_SUBSCRIPTION"] = 18] = "DRIVE_IN_SUBSCRIPTION";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["DRIVE_IN_EMPLOYEE"] = 19] = "DRIVE_IN_EMPLOYEE";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["BROWSER_APP_SUNSETPOINTS"] = 20] = "BROWSER_APP_SUNSETPOINTS";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["MOBILE_APP_SUNSETPOINTS"] = 21] = "MOBILE_APP_SUNSETPOINTS";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["KIOSK_SUNSETPOINTS"] = 22] = "KIOSK_SUNSETPOINTS";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["DRIVE_IN_SUSETPOINTS"] = 23] = "DRIVE_IN_SUSETPOINTS";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["DRIVE_THROUGH_BROWSER_MOBILE"] = 24] = "DRIVE_THROUGH_BROWSER_MOBILE";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["DRIVE_THROUGH_BROWSER_DESKTOP"] = 25] = "DRIVE_THROUGH_BROWSER_DESKTOP";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["DRIVE_THROUGH_APP"] = 26] = "DRIVE_THROUGH_APP";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["DRIVE_THROUGH_APP_PLUS"] = 27] = "DRIVE_THROUGH_APP_PLUS";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["DRIVE_THROUGH_APP_POINT"] = 28] = "DRIVE_THROUGH_APP_POINT";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["DRIVE_THROUGH_BROWSER_MOBILE_PLUS"] = 29] = "DRIVE_THROUGH_BROWSER_MOBILE_PLUS";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["DRIVE_THROUGH_BROWSER_MOBILE_POINT"] = 30] = "DRIVE_THROUGH_BROWSER_MOBILE_POINT";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["DRIVE_THROUGH_BROWSER_DESKTOP_PLUS"] = 31] = "DRIVE_THROUGH_BROWSER_DESKTOP_PLUS";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["DRIVE_THROUGH_BROWSER_DESKTOP_POINT"] = 32] = "DRIVE_THROUGH_BROWSER_DESKTOP_POINT";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["DRIVE_THROUGH_BROWSER_MOBILE_EMPLOYEE"] = 33] = "DRIVE_THROUGH_BROWSER_MOBILE_EMPLOYEE";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["DRIVE_THROUGH_BROWSER_DESKTOP_EMPLOYEE"] = 34] = "DRIVE_THROUGH_BROWSER_DESKTOP_EMPLOYEE";
    OnlinePosOrderTypeEnum[OnlinePosOrderTypeEnum["DRIVE_THROUGH_APP_EMPLOYEE"] = 35] = "DRIVE_THROUGH_APP_EMPLOYEE";
})(OnlinePosOrderTypeEnum || (OnlinePosOrderTypeEnum = {}));
